import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Sedancabserviceforcorporate() {

const cardData = {
keyword: "Sedan Cab Service for Corporate Employees Pune",
headingDescription: "Citysky Cabs provides sedan cab services for corporate employees in Pune, supporting regular office commuting, employee pickup and drop, IT workforce transportation, business travel, airport transfers, and corporate outstation journeys. Sedan vehicles can be arranged for individual employees, small teams, executives, and staff groups requiring comfortable and practical transportation. Daily and monthly arrangements can be planned around office timings, shift schedules, residential pickup points, and company travel requirements across major employment corridors such as Hinjewadi, Kharadi, Hadapsar, Magarpatta City, Viman Nagar, Baner, Pimpri Chinchwad, Yerawada, Kalyani Nagar, and Pune International Airport.",
topPlaces: [
{
title: "Hinjewadi IT Park",
description: "Hinjewadi IT Park is a major technology and employment destination with a large workforce travelling to offices every day. Sedan corporate cabs can support employee pickup and drop, shift transportation, business travel, airport transfers, and scheduled IT employee mobility."
},
{
title: "Kharadi EON IT Park",
description: "Kharadi EON IT Park is a prominent corporate and technology hub in eastern Pune. Sedan transportation can help companies arrange employee commuting, office pickup and drop, client travel, business meetings, airport transfers, and regular corporate mobility."
},
{
title: "Hadapsar",
description: "Hadapsar has several IT, commercial, industrial, and residential areas with employees travelling on fixed schedules. Sedan employee transportation can be organized for daily office commuting, monthly routes, staff pickup and drop, airport journeys, and business travel."
},
{
title: "Magarpatta City",
description: "Magarpatta City is an established business and residential destination with a large professional workforce. Sedan corporate cabs can support employees travelling to offices, business meetings, airport transfers, corporate events, and other scheduled professional destinations."
},
{
title: "Viman Nagar",
description: "Viman Nagar is a major commercial and residential area close to Pune International Airport. Sedan cabs can provide employee transportation between residences and offices while also supporting airport travel, business appointments, executive movement, and corporate guest transfers."
},
{
title: "Baner",
description: "Baner is an important corporate, commercial, and residential corridor with offices and business establishments. Sedan employee cabs can be arranged for office pickup and drop, staff transportation, corporate meetings, airport transfers, and scheduled local travel."
},
{
title: "Pimpri Chinchwad",
description: "Pimpri Chinchwad contains extensive industrial, manufacturing, commercial, and residential zones with regular workforce transportation requirements. Sedan cabs can support employee commuting, factory staff travel, office transfers, and corporate business journeys."
},
{
title: "Yerawada",
description: "Yerawada provides access to several commercial, residential, and employment destinations in eastern and central Pune. Corporate sedan transportation can connect employees with offices, business locations, airport routes, and nearby corporate corridors."
},
{
title: "Kalyani Nagar",
description: "Kalyani Nagar includes corporate offices, hotels, commercial establishments, and residential communities. Sedan corporate cabs can be used for employee commuting, executive travel, client movement, business meetings, airport transfers, and professional events."
},
{
title: "Pune International Airport",
description: "Pune International Airport is an important destination for corporate employees, executives, and business visitors. Sedan corporate airport cabs can provide scheduled transfers between the airport, offices, hotels, residences, and other business locations."
}
],
services: [
{
name: "Sedan Corporate Cab Pune",
description: "Sedan Corporate Cab Pune provides comfortable sedan transportation for employees, executives, clients, and business visitors. Services can support office commuting, meetings, airport transfers, corporate events, and regular professional travel."
},
{
name: "Sedan Corporate Taxi Pune",
description: "Sedan Corporate Taxi Pune provides practical sedan-based transportation for companies managing regular employee and business travel. Cabs can be scheduled for office routes, airport journeys, meetings, client transfers, and corporate events."
},
{
name: "Sedan Cab for Employees Pune",
description: "Sedan Cab for Employees Pune supports regular staff commuting between residential pickup points and workplaces. Sedan vehicles can be arranged according to employee locations, office schedules, shift timings, and recurring transportation requirements."
},
{
name: "Sedan Employee Transportation Pune",
description: "Sedan Employee Transportation Pune provides scheduled employee movement using comfortable sedan vehicles. Services can cover daily office commuting, shift travel, pickup and drop routes, business movement, and corporate transportation requirements."
},
{
name: "Corporate Sedan Cab Service Pune",
description: "Corporate Sedan Cab Service Pune provides sedan transportation for employees, executives, clients, and business guests. Companies can arrange services for daily office travel, meetings, airport transfers, corporate events, and scheduled professional journeys."
},
{
name: "Corporate Sedan Taxi Pune",
description: "Corporate Sedan Taxi Pune offers sedan taxi arrangements for organizations requiring dependable employee and business transportation. Vehicles can support office commuting, executive travel, client pickups, airport transfers, and local corporate travel."
},
{
name: "Sedan Office Pickup Drop Pune",
description: "Sedan Office Pickup Drop Pune helps companies arrange regular employee travel between residential areas and office locations. Pickup routes can be planned around employee addresses, office reporting times, shift schedules, and recurring working hours."
},
{
name: "Sedan Employee Pickup Drop Pune",
description: "Sedan Employee Pickup Drop Pune provides scheduled transportation for employees travelling to and from their workplaces. Sedan routes can be organized according to employee locations, office timings, shift requirements, and company transportation policies."
},
{
name: "Sedan Cab Booking for Corporate Pune",
description: "Sedan Cab Booking for Corporate Pune helps companies arrange sedan vehicles for planned employee and business transportation. Bookings can cover office commuting, meetings, airport transfers, client travel, events, and corporate outstation journeys."
},
{
name: "Sedan Cab Rental for Corporate Pune",
description: "Sedan Cab Rental for Corporate Pune provides rental sedan arrangements for organizations requiring vehicles for employees, executives, clients, and guests. Rentals can be planned for daily, monthly, event-based, local, and intercity corporate travel."
},
{
name: "Sedan Car Rental for Employees Pune",
description: "Sedan Car Rental for Employees Pune supports companies requiring sedan vehicles for recurring staff transportation. Cars can be arranged for office commuting, employee pickup and drop, shift travel, business mobility, and scheduled workplace transportation."
},
{
name: "AC Sedan Corporate Cab Pune",
description: "AC Sedan Corporate Cab Pune provides air-conditioned sedan transportation for employees, executives, and business visitors. Vehicles can be used for daily commuting, meetings, airport transfers, client travel, and corporate journeys across Pune."
},
{
name: "Affordable Sedan Corporate Cab Pune",
description: "Affordable Sedan Corporate Cab Pune provides practical sedan transportation options for companies managing employee and business travel requirements. Services can be structured for recurring office commuting, airport travel, meetings, and corporate mobility."
},
{
name: "Sedan Cab with Driver Pune",
description: "Sedan Cab with Driver Pune provides a sedan vehicle along with driver support for corporate employees and business travellers. This option can support office travel, executive movement, airport transfers, meetings, and longer professional journeys."
},
{
name: "Monthly Sedan Corporate Cab Pune",
description: "Monthly Sedan Corporate Cab Pune provides recurring sedan transportation for organizations with ongoing employee mobility requirements. Monthly arrangements can support fixed office routes, employee pickup and drop, shift travel, and regular corporate journeys."
},
{
name: "Daily Sedan Office Cab Pune",
description: "Daily Sedan Office Cab Pune provides regular sedan transportation for employees travelling to and from offices. Daily routes can be planned around reporting times, employee pickup points, working hours, and evening return schedules."
},
{
name: "Sedan Corporate Airport Cab Pune",
description: "Sedan Corporate Airport Cab Pune supports corporate employees, executives, clients, and guests travelling to or from Pune International Airport. Sedan transfers can be scheduled according to flight timings and business itineraries."
},
{
name: "Sedan Corporate Outstation Cab Pune",
description: "Sedan Corporate Outstation Cab Pune provides sedan transportation for business journeys outside Pune. Vehicles can support employee travel, client visits, meetings, industrial trips, conferences, training programs, and other intercity corporate requirements."
},
{
name: "Sedan Cab for IT Employees Pune",
description: "Sedan Cab for IT Employees Pune supports technology professionals travelling to major IT parks and corporate offices. Sedan transportation can accommodate regular office commuting, shift travel, airport transfers, and scheduled business mobility."
},
{
name: "Sedan Cab for Business Travel Pune",
description: "Sedan Cab for Business Travel Pune provides convenient transportation for professionals travelling to meetings, client offices, business parks, industrial locations, and corporate events. Driver-supported sedan travel can be arranged for local and outstation journeys."
},
{
name: "Sedan Corporate Cab Near Me Pune",
description: "Sedan Corporate Cab Near Me Pune helps businesses arrange sedan transportation around Pune's office, IT, industrial, and commercial corridors. Services can support employee commuting, meetings, airport travel, client movement, and recurring corporate requirements."
},
{
name: "Sedan Staff Transportation Pune",
description: "Sedan Staff Transportation Pune provides regular transportation for office staff and employees using comfortable sedan vehicles. Routes can be planned around staff locations, office schedules, shifts, and recurring company transportation requirements."
},
{
name: "Sedan Company Employee Cab Pune",
description: "Sedan Company Employee Cab Pune helps organizations arrange dedicated sedan transportation for their workforce. Services can cover employee pickup and drop, office commuting, shift transportation, business travel, and scheduled corporate movement."
},
{
name: "Private Sedan Corporate Rental Pune",
description: "Private Sedan Corporate Rental Pune provides dedicated sedan vehicles for companies requiring private transportation for employees, executives, clients, or business guests. Rental arrangements can cover meetings, airport transfers, events, and regular professional travel."
},
{
name: "Sedan Office Transportation Service Pune",
description: "Sedan Office Transportation Service Pune provides structured sedan transportation for employees travelling between homes and corporate workplaces. Services can be organized around office timings, pickup routes, employee locations, and recurring business schedules."
}
],
tableData: [
["Sedan Corporate Cab Pune"],
["Sedan Corporate Taxi Pune"],
["Sedan Cab for Employees Pune"],
["Sedan Employee Transportation Pune"],
["Corporate Sedan Cab Service Pune"],
["Corporate Sedan Taxi Pune"],
["Sedan Office Pickup Drop Pune"],
["Sedan Employee Pickup Drop Pune"],
["Sedan Cab Booking for Corporate Pune"],
["Sedan Cab Rental for Corporate Pune"],
["Sedan Car Rental for Employees Pune"],
["AC Sedan Corporate Cab Pune"],
["Affordable Sedan Corporate Cab Pune"],
["Sedan Cab with Driver Pune"],
["Monthly Sedan Corporate Cab Pune"],
["Daily Sedan Office Cab Pune"],
["Sedan Corporate Airport Cab Pune"],
["Sedan Corporate Outstation Cab Pune"],
["Sedan Cab for IT Employees Pune"],
["Sedan Cab for Business Travel Pune"],
["Sedan Corporate Cab Near Me Pune"],
["Sedan Staff Transportation Pune"],
["Sedan Company Employee Cab Pune"],
["Private Sedan Corporate Rental Pune"],
["Sedan Office Transportation Service Pune"]
],
whychoose: [
{
WhyChooseheading: "Practical Sedan Transportation for Employees",
WhyChoosedescription: "Sedan cabs provide a practical transportation option for individual employees, small teams, executives, and staff members travelling between residences and corporate workplaces. Routes can be organized around office schedules and employee pickup locations."
},
{
WhyChooseheading: "Daily Office Pickup and Drop",
WhyChoosedescription: "Companies can arrange recurring sedan pickup and drop transportation for employees travelling to and from offices. Daily schedules can be aligned with reporting times, working hours, shift requirements, and regular evening return journeys."
},
{
WhyChooseheading: "Monthly Corporate Arrangements",
WhyChoosedescription: "Organizations with ongoing employee transportation requirements can use monthly sedan cab arrangements. Regular routes, pickup points, vehicle requirements, and travel schedules can be planned according to workforce locations and company operating hours."
},
{
WhyChooseheading: "Support for IT Employees",
WhyChoosedescription: "Sedan transportation can support professionals travelling to Pune's major technology corridors such as Hinjewadi, Kharadi, Magarpatta, and other business locations. Services can accommodate regular office travel, shift schedules, airport journeys, and corporate mobility."
},
{
WhyChooseheading: "Comfortable AC Sedan Options",
WhyChoosedescription: "Air-conditioned sedans can provide a comfortable travel environment for employees and business professionals during daily commuting and corporate journeys. Vehicle arrangements can be matched with passenger requirements and travel schedules."
},
{
WhyChooseheading: "Driver-Supported Corporate Travel",
WhyChoosedescription: "Companies and professionals can use sedan cabs with driver support for office transportation, executive travel, client visits, airport transfers, and business meetings. This allows passengers to focus on their work while travelling."
},
{
WhyChooseheading: "Airport and Business Transfers",
WhyChoosedescription: "Sedan corporate cabs can be arranged for transportation between Pune International Airport, offices, hotels, residences, and business locations. Airport journeys can be scheduled around flight timings and professional itineraries."
},
{
WhyChooseheading: "Local and Outstation Employee Travel",
WhyChoosedescription: "Sedan transportation can cover regular Pune commuting as well as outstation corporate journeys. Employees and business professionals can use the service for client visits, meetings, industrial travel, conferences, training programs, and other scheduled work-related trips."
}
]
};










const faqData = [
{
question: "How can companies arrange sedan cab service for corporate employees in Pune?",
answer: "Companies can arrange sedan transportation by sharing employee pickup locations, office addresses, reporting times, travel schedules, passenger requirements, and service duration with Citysky Cabs. The information helps plan regular employee transportation for offices, business parks, industrial areas, and other workplace locations across Pune."
},
{
question: "Can Citysky Cabs provide daily sedan transportation for office employees in Pune?",
answer: "Organizations requiring regular employee travel can enquire about daily sedan cab arrangements for office pickup and drop services. Employee addresses, pickup points, shift timings, working days, and office locations can be discussed to structure transportation around the company's operating schedule."
},
{
question: "Which corporate employees can use sedan cab services in Pune?",
answer: "Sedan cabs can be suitable for employees, managers, executives, consultants, and other professionals who need reliable transportation between their homes and workplaces. Companies can also discuss sedan arrangements for employees travelling to meetings, client locations, training centers, or other business destinations."
},
{
question: "Can sedan cabs be used for employee pickup and drop in Pune?",
answer: "Employee pickup and drop transportation can be planned using sedan cars based on the organization's route and timing requirements. Multiple pickup points, employee locations, office reporting times, shift schedules, and return trips can be considered while discussing the required corporate cab arrangement with Citysky Cabs."
},
{
question: "Are sedan cab services available for employees working in Pune IT companies?",
answer: "IT companies and technology businesses can enquire about sedan transportation for employees working at offices in areas such as Hinjewadi, Kharadi, Viman Nagar, Baner, Hadapsar, and other business locations. Pickup schedules and employee routes can be planned according to the company's working hours."
},
{
question: "Can corporate employees use sedan cabs for early morning or late-night shifts?",
answer: "Companies with employees working in different shifts can discuss transportation requirements for early morning, evening, or late-night office timings. Providing shift schedules, employee pickup points, and office locations allows Citysky Cabs to understand the timing and route requirements for the proposed sedan service."
},
{
question: "Can companies hire sedan cabs for corporate meetings and official travel in Pune?",
answer: "Sedan cars can also be arranged for employees travelling to client meetings, branch offices, conferences, training programs, business appointments, and other official destinations. The travel date, passenger count, pickup point, destinations, and expected duration can be shared when planning the corporate journey."
},
{
question: "Can Citysky Cabs provide sedan service for employees travelling to Pune Airport?",
answer: "Corporate employees and visiting professionals can use sedan cabs for airport transfers between Pune Airport, offices, hotels, and residences. Companies can provide passenger details, flight information, luggage requirements, pickup address, and required reporting time while arranging airport transportation."
},
{
question: "Can sedan cab services be arranged for corporate employees on a monthly basis?",
answer: "Organizations with recurring employee transportation requirements can enquire about monthly sedan cab arrangements. Details such as the number of employees, pickup locations, office address, working days, shift timings, and expected daily usage can be discussed to determine a suitable recurring transportation plan."
},
{
question: "What information is required to arrange sedan cab service for corporate employees in Pune?",
answer: "Companies can provide employee pickup addresses or common pickup points, office location, reporting and departure timings, number of passengers, required service days, and travel frequency. Information about multiple shifts, airport transfers, official travel, or occasional outstation requirements can also be included when discussing the transportation arrangement."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Akash Jadhav",
feedback:
"Our office needed sedan transportation for a small group of employees travelling from different areas of Pune to the workplace every day. Citysky Cabs discussed the pickup points and office timings with us, which made it easier for our team to organize the daily employee travel schedule.",
rating: 5
},
{
id: 2,
name: "Miss. Pooja Bhosale",
feedback:
"We required a sedan for an employee who had an early morning shift and was travelling from Kharadi to our office regularly. After sharing the timings and pickup details with Citysky Cabs, the transportation was arranged around the employee's work schedule and was convenient for our office team to coordinate.",
rating: 5
}
];













































































































    const Images = [

    { place: "/images/keyword/1.jpg", text: "Innova Crysta Cab in Pune", link: "innova-crysta-cab-in-pune" },

    { place: "/images/keyword/2.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },

    { place: "/images/keyword/3.jpg", text: "Innova Crysta Cabs / Taxi Booking in Pune", link: "innova-crysta-cabs-taxi-booking-in-pune" },

    { place: "/images/keyword/4.jpg", text: "Pune to Mahabaleshwar Innova Crysta Cab", link: "pune-to-mahabaleshwar-innova-crysta-cab" },

    { place: "/images/keyword/5.jpg", text: "Book Innova Crysta for Outstation From Pune", link: "book-innova-crysta-for-outstation-from-pune" },

    { place: "/images/keyword/6.jpg", text: "Innova Crysta Cabs for Pune Airport", link: "innova-crysta-cabs-for-pune-airport" },

    { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Airport Innova Crysta", link: "pune-to-mumbai-airport-innova-crysta" },

    { place: "/images/keyword/8.jpg", text: "Innova Crysta Cab for Corporate Office", link: "innova-crysta-cab-for-corporate-office" },

    { place: "/images/keyword/9.jpg", text: "Mumbai Airport to Pune Innova Crysta Cabs", link: "mumbai-airport-to-pune-innova-crysta-cabs" },

    { place: "/images/keyword/10.jpg", text: "Pune to Shirdi Innova Crysta", link: "pune-to-shirdi-innova-crysta" },

    { place: "/images/keyword/11.jpg", text: "Pune Aurangabad Innova Crysta Cab Service", link: "pune-aurangabad-innova-crysta-cab-service" },

    { place: "/images/keyword/12.jpg", text: "Pune to Goa Innova Crysta Cab", link: "pune-to-goa-innova-crysta-cab" },

    { place: "/images/keyword/13.jpg", text: "Pune to Bangalore Innova Crysta Cab", link: "pune-to-bangalore-innova-crysta-cab" },

    { place: "/images/keyword/14.jpg", text: "Pune to Hyderabad Innova Crysta Rental Cab", link: "pune-to-hyderabad-innova-crysta-rental-cab" },

    { place: "/images/keyword/15.jpg", text: "Innova Crysta on Rent in Pune", link: "innova-crysta-on-rent-in-pune-2" },

    { place: "/images/keyword/16.jpg", text: "Pune to Lavasa Innova Crysta Cab Booking", link: "pune-to-lavasa-innova-crysta-cab-booking" },

    { place: "/images/keyword/17.jpg", text: "Pune Darshan Innova Crysta Cabs", link: "pune-darshan-innova-crysta-cabs" },

    { place: "/images/keyword/18.jpg", text: "Innova Crysta Cabs in Pune", link: "innova-crysta-cabs-in-pune" },

    { place: "/images/keyword/19.jpg", text: "Innova Car Rental In Pune", link: "innova-car-rental-in-pune" },

    { place: "/images/keyword/20.jpg", text: "Innova Taxi Service in Pune", link: "innova-taxi-service-in-pune" },

    { place: "/images/keyword/21.jpg", text: "Book Innova for Outstation Pune", link: "book-innova-for-outstation-pune" },

    { place: "/images/keyword/22.jpg", text: "Innova Crysta On Rent In Pune", link: "innova-crysta-on-rent-in-pune-3" },

    { place: "/images/keyword/23.jpg", text: "Pune to Mahabaleshwar Panchgani Innova Crysta Cabs", link: "pune-to-mahabaleshwar-panchgani-innova-crysta-cabs" },

    { place: "/images/keyword/24.jpg", text: "Pune to Outstation Innova Crysta Booking", link: "pune-to-outstation-innova-crysta-booking" },

    { place: "/images/keyword/25.jpg", text: "Innova Crysta on Rent in Pune", link: "innova-crysta-on-rent-in-pune-4" },


];















const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Sedan Cab Service for Corporate Employees Pune",
  "image": "https://www.cityskycab.in/assets/images/sedan-cab-service-for-corporate-employees-pune.webp",
  "description": "Sedan Cab Service for Corporate Employees Pune from Citysky Cabs is designed for companies, offices and business teams that require comfortable and practical transportation for their employees. Sedan Corporate Cab Pune and Sedan Corporate Taxi Pune are suitable for regular office commuting, executive travel and scheduled company transportation. Sedan Cab for Employees Pune and Sedan Employee Transportation Pune can be arranged around employee residential areas, office locations and working hours. Corporate Sedan Cab Service Pune and Corporate Sedan Taxi Pune provide convenient options for businesses managing daily staff movement, while Sedan Office Pickup Drop Pune and Sedan Employee Pickup Drop Pune can be planned according to fixed routes and shift schedules. Sedan Cab Booking for Corporate Pune and Sedan Cab Rental for Corporate Pune offer flexible arrangements for recurring or occasional corporate travel. Sedan Car Rental for Employees Pune is suitable for companies that need comfortable vehicles for staff transportation, and AC Sedan Corporate Cab Pune provides a convenient option for employees travelling in Pune's varied weather conditions. Citysky Cabs can also arrange sedan transportation for airport transfers, business meetings, client visits and outstation corporate journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Citysky Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.cityskycab.in/sedan-cab-service-for-corporate-employees-pune"
  }
};


    return (
        <div>



<Helmet>
  <title>
    Sedan Cab Service for Corporate Employees Pune | AC Sedan Employee Transport | +91 8554819191
  </title>

  <meta
    name="description"
    content="Sedan Cab Service for Corporate Employees Pune by Citysky Cabs for office pickup and drop, employee transportation, corporate sedan rental, daily commuting, airport transfers and business travel."
  />

  <meta
    name="keywords"
    content="Sedan Cab Service for Corporate Employees Pune, Sedan Corporate Cab Pune, Sedan Corporate Taxi Pune, Sedan Cab for Employees Pune, Sedan Employee Transportation Pune, Corporate Sedan Cab Service Pune, Corporate Sedan Taxi Pune, Sedan Office Pickup Drop Pune, Sedan Employee Pickup Drop Pune, Sedan Cab Booking for Corporate Pune, Sedan Cab Rental for Corporate Pune, Sedan Car Rental for Employees Pune, AC Sedan Corporate Cab Pune, Sedan Corporate Employee Transport Pune, Sedan Office Cab Pune, Sedan Employee Cab Pune, Sedan Corporate Car Rental Pune, Sedan Company Cab Pune, Sedan Staff Transportation Pune, Sedan Employee Taxi Pune, Sedan Corporate Travel Pune, Sedan Business Travel Cab Pune, Sedan Airport Corporate Cab Pune, Sedan Outstation Corporate Cab Pune, Pune sedan cab service for employees, Pune corporate sedan taxi, Pune employee sedan transportation, Pune office sedan pickup drop, Pune corporate sedan rental, Pune employee car rental, Pune AC sedan cab, Pune company employee sedan cab, Pune daily employee sedan transport, Pune monthly corporate sedan cab, Pune corporate airport sedan, Pune business sedan taxi, Pune executive sedan cab, Pune corporate staff sedan service, Pune employee pickup and drop sedan"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div className="sisf-banner sis-br-radius mt-3 position-relative">
                <div className="banner-img">
                    <figure>
                      {/* <img
                            src="/images/page-banner.jpg"
                            alt="Mauliwala Travels Urbania and Mini Bus Rental Pune"
                        /> */}
                    </figure>
                </div>

                <div className="sisf-page-title sisf-m sisf-title--standard sisf-alignment--center">
                    <div className="sisf-m-inner container">
                        <div className="sisf-m-content sisf-content-grid">
                            <h1 className="sisf-m-title text-white sis-text-anime-style-3 entry-title">
                                {cardData.keyword}
                            </h1>
                        </div>
                    </div>
                </div>
            </div>














            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keywords/154.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Citysky Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Citysky Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Citysky Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918554819191" className="pc-call">+91 8554819191 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+918459883515" className="pc-call">+91 8459883515 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918459883515
"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918459883515" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@cityskycab.in" className="pc-email">
                                            booking@cityskycab.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Citysky Cabs</strong><br />

                                            Office No,307,3rd Floor,
                                            52, Sinhgad Rd, Wadgaon Budruk,
                                            Narhe, Pune, Maharashtra,India- 411041.






                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Sedancabserviceforcorporate;